import axios from "axios";
import React, { useEffect, useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { useLocation } from "react-router-dom";
import './WorkDetails.css'

const WorkDetails = () => {
  const [recoveryData, setRecoveryData] = useState();
  const [workDetails, setWorkDetails] = useState();
  const location = useLocation();
  //     staffName: "Saravanan",
  //     bikeType: "Own Bike",
  //     kmTravel: "16 KM",
  //     cableUsed: "12 KM",
  //     workTime: "2 Hours 30 Minutes",
  //     extras: false,
  //   },
  //   {
  //     staffName: "Rajesh",
  //     bikeType: "Company Bike",
  //     kmTravel: "20 KM",
  //     cableUsed: "15 KM",
  //     workTime: "3 Hours",
  //     extras: true,
  //   },
  //   {
  //     staffName: "Karthik",
  //     bikeType: "Own Bike",
  //     kmTravel: "10 KM",
  //     cableUsed: "8 KM",
  //     workTime: "1 Hour 45 Minutes",
  //     extras: false,
  //   },
  //   {
  //     staffName: "Arun",
  //     bikeType: "Company Bike",
  //     kmTravel: "25 KM",
  //     cableUsed: "20 KM",
  //     workTime: "4 Hours",
  //     extras: true,
  //   },
  //   {
  //     staffName: "Vikram",
  //     bikeType: "Own Bike",
  //     kmTravel: "18 KM",
  //     cableUsed: "14 KM",
  //     workTime: "2 Hours 15 Minutes",
  //     extras: false,
  //   },
  // ];
  const apiUrl = process.env.REACT_APP_API_BASE_URL;

  // Helper function to format work time
  const formatWorkTime = (minutes) => {
    if (!minutes) return "-";
    const hours = Math.floor(minutes / 60);
    const mins = minutes % 60;
    return (
      `${hours > 0 ? `${hours} Hour${hours !== 1 ? "s" : ""}` : ""} ${
        mins > 0 ? `${mins} Minute${mins !== 1 ? "s" : ""}` : ""
      }`.trim() || "-"
    );
  };

  // Format date function
  const formatDate = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    return date.toLocaleDateString("en-GB"); // DD/MM/YYYY format
  };

  useEffect(() => {
    if (recoveryData?._id) {
      axios
        .get(`${apiUrl}workdetails/${recoveryData._id}`)
        .then((res) => {
          setWorkDetails(res.data);
        })
        .catch((error) => {
          console.error("Error fetching work details:", error);
        });
    }
  }, [recoveryData, apiUrl]);

  useEffect(() => {
    axios
      .get(`${apiUrl}recovery-get`, {
        params: { id: location.state?.id },
      })
      .then((res) => {
        setRecoveryData(res.data);
        console.log(res.data); // Check the complete response structure
      })
      .catch((error) => {
        console.error("Error fetching recovery data:", error);
      });
  }, [apiUrl, location.state?.id]);

  return (
    <div>
      <Container>
        <form>
          <Row className="text-start lead-id-row  mb-4 mt-4 ms-4">
            <p className=" paragraph-lead-id">
              <span className="lead-start-date">
                Lead Started Date -
                <span className="text-primary">12.04.2025</span>
              </span>
            </p>
          </Row>

          <table className="table table-bordered mt-5">
            <thead className="table-th text-center">
              <tr>
                <th>Staff Name</th>
                <th>Bike Type</th>
                <th>KM Travel</th>
                <th>Cable Used</th>
                <th>Work Time</th>
              </tr>
            </thead>
            <tbody>
              {Array.isArray(workDetails) && workDetails.length > 0 ? (
                workDetails.map((work) => (
                  <tr key={work._id} className="text-center">
                    <td>{work.staffName || "-"}</td>
                    <td>{work.bikeType || "-"}</td>
                    <td>
                      {work.kmTraveled !== null ? `${work.kmTraveled} KM` : "-"}
                    </td>
                    <td>
                      {work.cableUsed !== null ? `${work.cableUsed} KM` : "-"}
                    </td>
                    <td>{formatWorkTime(work.workTime)}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="6" className="text-center">
                    No data found
                  </td>
                </tr>
              )}
            </tbody>
          </table>

          {/* <div className="mt-5 mb-5 fiber-team-upload-photo">
            <label>
              <strong>Photos</strong>
            </label>
            <div className="fiber-team-photos mt-3 mb-4">
              <Row className="mt-3">
                <Col className="text-center">
                  <div className="ms-4">
                    <p>
                      <strong>Cable</strong>
                    </p>
                    <img
                      src=""
                      width="150px"
                      height="130px"
                      style={{ borderRadius: "5px" }}
                    />
                    <p style={{ fontSize: "11px" }} className="mt-2">
                      By Saravanan <span className="ms-4">12/12/2024</span>
                    </p>
                  </div>
                </Col>
                <Col className="text-center">
                  <div className="ms-4">
                    <img
                      src="https://www.fujikura.co.uk/netalogue/news/Fibre%20Optic%20Splicing%20Explained.jpg"
                      width="150px"
                      height="130px"
                      style={{ borderRadius: "5px" }}
                    />
                    <p style={{ fontSize: "11px" }} className="mt-2">
                      By Saravanan <span className="ms-4">12/12/2024</span>
                    </p>
                  </div>
                </Col>
                <Col className="text-center">
                  <div className="ms-4">
                    <img
                      src=""
                      width="150px"
                      height="130px"
                      style={{ borderRadius: "5px" }}
                    />
                    <p style={{ fontSize: "11px" }} className="mt-2">
                      By Saravanan <span className="ms-4">12/12/2024</span>
                    </p>
                  </div>
                </Col>
                <Col className="text-center">
                  <div className="ms-4">
                    <img
                      src=""
                      width="150px"
                      height="130px"
                      style={{ borderRadius: "5px" }}
                    />
                    <p style={{ fontSize: "11px" }} className="mt-2">
                      By Saravanan <span className="ms-4">12/12/2024</span>
                    </p>
                  </div>
                </Col>
              </Row>
            </div>

            <label>
              <strong>Updateds Photos</strong>
            </label>

            <div className="fiber-team-photos mt-3 mb-4">
              <Row className="mt-3">
                <Col className="text-center">
                  <div className="ms-4">
                    <img
                      src=""
                      width="150px"
                      height="130px"
                      style={{ borderRadius: "5px" }}
                    />
                    <p style={{ fontSize: "11px" }} className="mt-2">
                      By Saravanan <span className="ms-4">12/12/2024</span>
                    </p>
                  </div>
                </Col>
                <Col className="text-center">
                  <div className="ms-4">
                    <img
                      src="https://www.fujikura.co.uk/netalogue/news/Fibre%20Optic%20Splicing%20Explained.jpg"
                      width="150px"
                      height="130px"
                      style={{ borderRadius: "5px" }}
                    />
                    <p style={{ fontSize: "11px" }} className="mt-2">
                      By Saravanan <span className="ms-4">12/12/2024</span>
                    </p>
                  </div>
                </Col>
                <Col className="text-center">
                  <div className="ms-4">
                    <img
                      src=""
                      width="150px"
                      height="130px"
                      style={{ borderRadius: "5px" }}
                    />
                    <p style={{ fontSize: "11px" }} className="mt-2">
                      By Saravanan <span className="ms-4">12/12/2024</span>
                    </p>
                  </div>
                </Col>
              </Row>
            </div>
          </div> */}

         <div className="mt-5 mb-5 recovery-photo-section p-3 rounded">
  <label>
    <strong>Photos</strong>
  </label>
  <div className="recovery-photo-wrapper mt-3 mb-4">
    {recoveryData?.workDetails?.photos?.length > 0 ? (
      <Row className="mt-3">
        {recoveryData.workDetails.photos.map((photo) => (
          <Col className="text-center" key={photo._id} xs={6} md={3}>
            <div className="ms-4">
              <img
                src={photo.image}
                width="150px"
                height="130px"
                style={{
                  borderRadius: "5px",
                  objectFit: "cover",
                }}
                alt={`Recovery by ${photo.staffName}`}
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src =
                    "https://placehold.co/150x130?text=No+Image";
                }}
              />
              <p style={{ fontSize: "11px" }} className="mt-2">
                By {photo.staffName}
                <span className="ms-4">{formatDate(photo.date)}</span>
              </p>
            </div>
          </Col>
        ))}
      </Row>
    ) : (
      <Row className="mt-3">
        <Col className="text-center">
          <p>No photos available</p>
        </Col>
      </Row>
    )}
  </div>
</div>

        </form>
      </Container>
    </div>
  );
};

export default WorkDetails;
